import Status from '@common/Status'
import {
  M_STATUS_REJECTED,
  M_STATUS_SUCCESS,
  M_STATUS_VERIFYING,
  THEME_BLACK_GOLD,
  THEME_TOP_WEDDING,
  THEME_WHITE_GOLD,
  THEME_WHITE_GREEN,
  THEME_WHITE_PINK,
  THEME_WHITE_RED,
  VIDEO_STATUS_REJECTED,
  VIDEO_STATUS_SUCCESS,
  VIDEO_STATUS_VERIFYING
} from '@constant'
import {
  isWeddingDressProperty,
  isWeddingEmceeProperty,
  isWeddingPlanProperty,
  isWeddingRingJewelryProperty
} from '@merchant-backend/util'
import { isSanDaProperty, isSiDaMember, isSiDaTeam } from '@util'
import React from 'react'
import {
  AskAnswer,
  BottomBar,
  ConsultGift,
  Coupon,
  EasyChat,
  Evaluate,
  Example,
  Gift,
  GroupCover,
  GroupInfo,
  GroupMember,
  Meal,
  MerchantActivity,
  MerchantHonor,
  MerchantPromise,
  MerchantUpdates,
  Notice,
  RecommendWindow,
  SiDaShopInfo
} from './Home/MobileShop/ShopArea'

/**
 *
 * 三大个人：
 店铺信息、团队、人气商家、公告、优惠券、咨询礼、到店礼、活动DIY、套餐、作品、评价、问大家、动态、底部条
 * 三大团队：
 团队封面、店铺信息、放心购、人气商家、公告、优惠券、咨询礼、到店礼、橱窗、套餐、作品、团队成员、评价、问大家、动态、底部条
 *
 */

/**
 * TODO
 * 根据不同类目、或四大个人/团队、或加盟店等获取装修模块
 */
export const getDecorationModules = () => {
  if (isSiDaMember()) {
    return [
      SiDaShopInfo,
      GroupInfo,
      MerchantHonor,
      Notice,
      Coupon,
      ConsultGift,
      Gift,
      MerchantActivity,
      Meal,
      Example,
      Evaluate,
      AskAnswer,
      MerchantUpdates,
      EasyChat,
      BottomBar
    ]
  }
  if (isSiDaTeam()) {
    return [
      GroupCover,
      SiDaShopInfo,
      MerchantHonor,
      MerchantPromise,
      Notice,
      Coupon,
      ConsultGift,
      Gift,
      MerchantActivity,
      RecommendWindow,
      Meal,
      Example,
      GroupMember,
      Evaluate,
      AskAnswer,
      MerchantUpdates,
      EasyChat,
      BottomBar
    ]
  }
}

export const getRealPhotoStyle = real_photos => {
  return {
    height: 260,
    backgroundSize: 'cover',
    backgroundImage: `url(${real_photos[0] && real_photos[0].cover_path})`,
    backgroundRepeat: 'no-repeat'
  }
}

/**
 * 获取商家主页显示的套餐个数
 */
export const getHomeMealCount = () => {
  if (isSiDaMember()) {
    return 4
  }

  if (isWeddingDressProperty() || isWeddingPlanProperty()) {
    return 3
  }

  if (isSiDaTeam() || isWeddingRingJewelryProperty()) {
    return 6
  }

  return 3
}

/**
 * 获取商家主页显示的案例个数
 */
export const getHomeCaseCount = () => {
  if (isWeddingDressProperty()) {
    return 10
  }

  if (isWeddingEmceeProperty()) {
    return 2
  }

  if (isSanDaProperty()) {
    return 3
  }

  return 6
}

const isBlackGold = theme => {
  return theme == THEME_BLACK_GOLD || theme == THEME_TOP_WEDDING
}

/**
 * 查看更多文字色
 */
export const getMoreTextColor = theme => {
  if (theme == THEME_WHITE_RED) {
    return '#578AFE'
  }

  if (
    theme == THEME_WHITE_GOLD ||
    theme == THEME_BLACK_GOLD ||
    theme == THEME_TOP_WEDDING
  ) {
    return '#E8B45E'
  }

  return '#FF801A'
}

/**
 * 公告喇叭
 */
export const getNoticeIcon = theme => {
  if (theme == THEME_BLACK_GOLD || theme == THEME_TOP_WEDDING) {
    return '//qnm.hunliji.com/o_1dnrj1540120a15utib12isl5kj.png'
  }

  return '//qnm.hunliji.com/o_1dnriqa1g1lkh1v8bq5643kbr2e.png'
}

/**
 * 放心购图片
 */
export const getBuyIcon = theme => {
  const common = '//qnm.hunliji.com/o_1dnrje869vl1bl81uhn1tcdrita.png'
  if (theme == THEME_BLACK_GOLD || theme == THEME_TOP_WEDDING) {
    return '//qnm.hunliji.com/o_1dnrje869har1lo3t0f1imf1oimb.png'
  }

  return common
}

/**
 * 收藏icon
 */
export const getCollectIcon = theme => {
  if (theme == THEME_BLACK_GOLD || theme == THEME_TOP_WEDDING) {
    return '//qnm.hunliji.com/o_1dnrlo88j167316viboh1vd711cgb.png'
  }

  return '//qnm.hunliji.com/o_1dnrlo88i1s8ejur1s5goftsnla.png'
}

/**
 * 地址icon
 */
export const getAddressIcon = theme => {
  if (theme == THEME_BLACK_GOLD || theme == THEME_TOP_WEDDING) {
    return '//qnm.hunliji.com/o_1dnrn5266gqt1r2u1apd1aaspqh9.png'
  }

  return '//qnm.hunliji.com/o_1djqdrppt948i7dmfebmo1m089.png'
}

/**
 * 箭头颜色
 */
export const getArrowColor = theme => {
  if (theme == THEME_BLACK_GOLD || theme == THEME_TOP_WEDDING) {
    return '#D5C8B4'
  }

  return '#999'
}

/**
 * 优惠券图片
 */
export const getCouponImg = theme => {
  if (
    theme == THEME_WHITE_GOLD ||
    theme == THEME_BLACK_GOLD ||
    theme == THEME_TOP_WEDDING
  ) {
    return '//qnm.hunliji.com/o_1dnr9hbjrm2iomokrn1dkgnfo9.png'
  }
  return '//qnm.hunliji.com/o_1cioivci68lf1rdv1opa164lqd9.png'
}

/**
 * 优惠券文字
 */
export const getCouponText = theme => {
  if (theme == THEME_BLACK_GOLD || theme == THEME_TOP_WEDDING) {
    return '#333'
  }

  return '#fff'
}

/**
 * 套餐价格
 */
export const getMealPriceColor = theme => {
  if (theme == THEME_WHITE_RED) {
    return '#F83244'
  }
  if (
    theme == THEME_WHITE_GOLD ||
    theme == THEME_BLACK_GOLD ||
    theme == THEME_TOP_WEDDING
  ) {
    return '#E8B45E'
  }

  return '#FF801A'
}

export const getViewMoreStyleNameWd = theme => {
  if (theme == THEME_WHITE_GOLD) {
    return 'whiteGold'
  }

  if (theme == THEME_BLACK_GOLD) {
    return 'blackGold'
  }

  return 'default'
}

export const getMealTitleColorWd = theme => {
  if (theme == THEME_WHITE_GOLD) {
    return '#000'
  }

  if (theme == THEME_BLACK_GOLD) {
    return '#D5C8B4'
  }

  return '#000'
}

export const getMealPriceColorWd = theme => {
  if (theme == THEME_WHITE_GOLD) {
    return '#E8B45E'
  }
  if (theme == THEME_BLACK_GOLD) {
    return '#E8B45E'
  }

  return '#FF264A'
}

/**
 * 套餐标题色
 */
export const getMealTitleColor = theme => {
  if (theme == THEME_BLACK_GOLD || theme == THEME_TOP_WEDDING) {
    return '#D5C8B4'
  }

  return '#000'
}

/**
 * 模块标题右侧颜色（除好评率）
 */
export const getHeaderRightTextColor = theme => {
  if (theme == THEME_BLACK_GOLD || theme == THEME_TOP_WEDDING) {
    return '#D5C8B4'
  }
  return '#666'
}

export const getUpdateDayTextColor = theme => {
  if (isBlackGold(theme)) {
    return '#E8B45E'
  }

  return '#333'
}

export const getUpdateMonthTextColor = theme => {
  if (isBlackGold(theme)) {
    return '#D5C8B4'
  }

  return '#999'
}

export const getUpdateContentTextColor = theme => {
  if (isBlackGold(theme)) {
    return '#D5C8B4'
  }

  return '#333'
}

/**
 * 商家荣誉、公告、咨询礼、到店礼文字颜色
 */
export const getNoticeGiftHonorTextColor = theme => {
  if (isBlackGold(theme)) {
    return '#d5c8b4'
  }
  return '#333'
}

/**
 * 用户评价
 * tabBg: TAB非选中背景色
 */
export const getEvaluateColor = theme => {
  if (theme == THEME_WHITE_RED) {
    return {
      tabBg: '#fff3f5',
      tabSelectedBg:
        'linear-gradient(152deg,rgba(255,91,106,1) 0%,rgba(248,50,68,1) 100%)',
      tabSelectedTextColor: '#fff',
      tabTextColor: '#333'
    }
  }

  if (theme == THEME_WHITE_GOLD) {
    return {
      tabBg: '#fff8ed',
      tabSelectedBg:
        'linear-gradient(152deg,rgba(232,180,94,1) 0%,rgba(224,171,84,1) 100%)',
      tabSelectedTextColor: '#fff',
      tabTextColor: '#242321'
    }
  }

  if (theme == THEME_BLACK_GOLD) {
    return {
      tabBg: '#d3c8b6',
      tabSelectedBg:
        'linear-gradient(152deg,rgba(245,199,124,1) 0%,rgba(232,180,94,1) 100%)',
      tabSelectedTextColor: '#232421',
      tabTextColor: '#666'
    }
  }

  if (theme == THEME_WHITE_PINK) {
    return {
      tabBg: '#fff3f5',
      tabSelectedBg:
        'linear-gradient(155deg,rgba(255,140,164,1) 0%,rgba(255,120,148,1) 100%)',
      tabSelectedTextColor: '#fff',
      tabTextColor: '#666'
    }
  }

  if (theme == THEME_WHITE_GREEN) {
    return {
      tabBg: '#edf8e3',
      tabSelectedBg:
        'linear-gradient(155deg,rgba(152,206,100,1) 0%,rgba(152,206,100,1) 100%)',
      tabSelectedTextColor: '#fff',
      tabTextColor: '#666'
    }
  }

  // 蓝色
  return {
    tabBg: '#eff8ff',
    tabSelectedBg:
      'linear-gradient(155deg,rgba(72,193,255,1) 0%,rgba(72,177,255,1) 100%)',
    tabSelectedTextColor: '#fff',
    tabTextColor: '#666'
  }
}

/**
 * 用户评价TAB选中背景色
 */
export const getEvaluateTabSelectedBgColor = theme => {
  if (theme == THEME_WHITE_RED) {
    return '#fff3f5'
  }

  if (theme == THEME_WHITE_GOLD) {
    return '#fff8ed'
  }

  if (theme == THEME_BLACK_GOLD) {
    return '#d3c8b6'
  }

  if (theme == THEME_WHITE_PINK) {
    return '#fff3f5'
  }

  if (theme == THEME_WHITE_GREEN) {
    return '#edf8e3'
  }

  // 蓝色
  return '#eff8ff'
}

export const getVideoStatus = (status, reason) => {
  return {
    [VIDEO_STATUS_VERIFYING]: <Status type="warning" />,
    [VIDEO_STATUS_SUCCESS]: <Status type="success" />,
    [VIDEO_STATUS_REJECTED]: <Status type="error" reason={reason} />
  }[+status]
}

export const getPendingStatus = (status, reason) => {
  if (status === null) {
    return null
  }

  return {
    [M_STATUS_VERIFYING]: <Status type="warning" />,
    [M_STATUS_SUCCESS]: <Status type="success" />,
    [M_STATUS_REJECTED]: <Status type="error" reason={reason} />
  }[+status]
}
